import React from 'react'
import { useComputed } from '@preact/signals-react'

import { AppAntSwitch } from '@components'
import { formData } from '@signals'


export default function OfficeCountrySelector() {

	const toggleSelectors = useComputed(() => formData.value?.isCheckedOffice)

	return <AppAntSwitch
		falseText="Country"
		trueText="Office"
		checked={!!toggleSelectors.value}
		onChange={e => {
			formData.value = { ...formData.value, isCheckedOffice: e.target.checked, idCountries: [], idOffices: [] }
		}}
	/>
}